import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Row, Col, Container, Accordion } from 'react-bootstrap';
import LicService from '../../../../services/licitacao';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import '../../../../styles/adequacoes.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [processo, setProcesso] = useState("");
    const [dataInicial, setDataInicial] = useState("");
    const [dataFinal, setDataFinal] = useState("");
    const [modalidade, setModalidade] = useState("");
    const [situacao, setSituacao] = useState("");
    const [unidadeGestora, setUnidadeGestora] = useState("");
    const [licitacao, setLicitacao] = useState("");
    const [ano, setAno] = useState("");
    const [objeto, setObjeto] = useState("");
    const [sit, setSit] = useState(props.situacao)
    const [mostra, setMostra] = useState(true);
    const pathName = window.location.pathname;

    const getTipo = (path) => {
        switch (path) {
            case '/transparencia/licitacao/expomacuco/2025':
                setAno("2025");
                setMostra(false);
                return { service: LicService.buscarExpo, type: "object" };

            case '/transparencia/licitacao/expomacuco/2024':
                setAno("2024");
                setMostra(false);
                return { service: LicService.buscarExpo, type: "object" };

            case '/transparencia/licitacao/expomacuco/2023':
                setAno("2023");
                setMostra(false);
                return { service: LicService.buscarExpo, type: "object" };

            case '/transparencia/licitacao/expomacuco/anteriores':
                setMostra(false);
                return { service: LicService.buscarExpoAnt, type: "object" };

            default:
                setMostra(true);
                return { service: LicService.buscar, type: "string" };
        }
    };

    useEffect(() => {
        setSit(props.situacao);
        getTipo(window.location.pathname);
    }, [window.location.pathname]);

    const busca = async (query) => {
        if (query === "") {
            await props.fetchLicsIn()
            setDataFinal("")
            setDataInicial("")
            setProcesso("")
            setObjeto("")
        } else {
            const { service, type } = getTipo(pathName);

            let response;
            if (type === "object") {
                // services buscarExpo e buscarExpoAnt
                response = await service(ano ? { ano, ...query } : query);
            } else {
                // service buscar → já espera string completa
                response = await service(query);
            }
            if (response.data.length >= 1) {
                props.setLics(response.data)
                props.setVazio(false)
                setDataFinal("")
                setDataInicial("")
                setProcesso("")
                setLicitacao("")
                setObjeto("")
            } else {
                props.setVazio(true)
                setDataFinal("")
                setDataInicial("")
                setProcesso("")
                setLicitacao("")
                setObjeto("")
            }
        }
    }

    const preparaQuery = async () => {
        let queryObj = {};
        let queryStr = "";

        // modalidade
        if (modalidade && modalidade !== "false") {
            queryObj.modalidade = modalidade;
            queryStr += `${queryStr ? "&" : ""}modalidade=${encodeURIComponent(modalidade)}`;
        }

        // situacao com fallback para sit
        const situacaoValor = (situacao && situacao !== "false") ? situacao : (typeof sit !== "undefined" && sit ? sit : null);
        if (situacaoValor) {
            queryObj.situacao = situacaoValor;
            queryStr += `${queryStr ? "&" : ""}situacao=${encodeURIComponent(situacaoValor)}`;
        }

        // licitacao
        if (licitacao) {
            queryObj.licitacao = licitacao;
            queryStr += `${queryStr ? "&" : ""}licitacao=${encodeURIComponent(licitacao)}`;
        }

        // dataInicial
        if (dataInicial) {
            queryObj.dataInicial = dataInicial;
            queryStr += `${queryStr ? "&" : ""}dataInicial=${dataInicial}`;
        }

        // unidadeGestora
        if (unidadeGestora && unidadeGestora !== "false") {
            queryObj.unidadeGestora = unidadeGestora;
            queryStr += `${queryStr ? "&" : ""}unidadeGestora=${encodeURIComponent(unidadeGestora)}`;
        }

        // dataFinal
        if (dataFinal) {
            queryObj.dataFinal = dataFinal;
            queryStr += `${queryStr ? "&" : ""}dataFinal=${dataFinal}`;
        }

        // objeto ou palavraChave (prioriza objeto)
        if (objeto) {
            queryObj.objeto = objeto;
            queryStr += `${queryStr ? "&" : ""}objeto=${encodeURIComponent(objeto)}`;
        }

        // ano
        if (ano) {
            queryObj.ano = ano;
            queryStr += `${queryStr ? "&" : ""}ano=${ano}`;
        }

        // processo
        if (processo) {
            queryObj.processo = processo;
            queryStr += `${queryStr ? "&" : ""}processo=${processo}`;
        }

        return { queryObj, queryStr };
    };

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let { queryObj, queryStr } = await preparaQuery();

        const { service, type } = getTipo(pathName);

        if (type === "object") {
            await busca(queryObj);
        } else {
            await busca(queryStr);
        }
    };

    return (
        <Fragment>
            <Container>
                <div className="da-espaco caixa-busca">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="objeto">
                                <Form.Label style={{ fontSize: "12px" }}>Objeto da Licitação</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="objeto"
                                    value={objeto}
                                    onChange={e => setObjeto(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="processo">
                                <Form.Label style={{ fontSize: "12px" }}>Número do processo (sem ano)</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="processo"
                                    value={processo}
                                    onChange={e => setProcesso(e.target.value)} />
                            </Form.Group>
                        </Col>
                        {mostra ?
                            <Col xs={12} lg={2}>
                                <Form.Group className="mb-3" controlId="ano">
                                    <Form.Label style={{ fontSize: "12px" }}>Ano do Processo</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </Form.Group>
                            </Col> : null}
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="processo">
                                <Form.Label style={{ fontSize: "12px" }}>Licitação/Pregão/Dispensa (número/ano)</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="licitacao"
                                    value={licitacao}
                                    onChange={e => setLicitacao(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <Form.Label style={{ fontSize: "12px" }}>Situação</Form.Label>
                                <Form.Select
                                    aria-label="Situação"
                                    name="situacao"
                                    onChange={e => setSituacao(e.target.value)}
                                >
                                    <option value="false">TODAS</option>
                                    <option value="Publicada">Publicada</option>
                                    <option value="Em Andamento">Em Andamento</option>
                                    <option value="Homologada">Homologada</option>
                                    <option value="Cancelada">Cancelada</option>
                                    <option value="Suspensa">Suspensa</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="dataInicial">
                                <Form.Label style={{ fontSize: "12px" }}>Data Inicial</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="dataInicial"
                                    value={dataInicial}
                                    onChange={e => setDataInicial(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="dataFinal">
                                <Form.Label style={{ fontSize: "12px" }}>Data Final</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="dataFinal"
                                    value={dataFinal}
                                    onChange={e => setDataFinal(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Modalidade">
                                <Form.Label style={{ fontSize: "12px" }}>Modalidade</Form.Label>
                                <Form.Select
                                    aria-label="Modalidade"
                                    name="modalidade"
                                    onChange={e => setModalidade(e.target.value)}
                                >
                                    <option value="false">TODAS</option>
                                    <option value="Carta Convite">Carta Convite</option>
                                    <option value="Concorrência">Concorrência</option>
                                    <option value="Chamamento Público para Credenciamento em Saúde">Chamamento Público para Credenciamento em Saúde</option>
                                    <option value="Concurso">Concurso</option>
                                    <option value="Leilão">Leilão</option>
                                    <option value="Pregão">Pregão</option>
                                    <option value="Pregão Eletrônico">Pregão Eletrônico</option>
                                    <option value="Ata de Adesão - SRP">Ata de Adesão - SRP</option>
                                    <option value="Tomada de Preço">Tomada de Preço</option>
                                    <option value="Dispensa">Dispensa</option>
                                    <option value="Inexigibilidade">Inexigibilidade</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {mostra ?
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="UnidadeGestora">
                                <Form.Label style={{ fontSize: "12px" }}>Unidade Gestora</Form.Label>
                                <Form.Select
                                    aria-label="Unidade Gestora"
                                    name="unidadeGestora"
                                    onChange={e => setUnidadeGestora(e.target.value)}
                                >
                                    <option value="false">TODAS</option>
                                    <option value="Prefeitura de Macuco">Prefeitura Municipal de Macuco</option>
                                    <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                    <option value="Fundo Municipal da Educação">Fundo Municipal da Educação</option>
                                    <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                    <option value="Fundo Municipal da Criança e do Adolescente">Fundo Municipal da Criança e do Adolescente</option>
                                    <option value="Fundo Municipal de Meio Ambiente">Fundo Municipal de Meio Ambiente</option>
                                </Form.Select>
                            </Form.Group>
                        </Col> : null }
                        <Col xs={12} lg={2}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Link to='/licitacao'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row> <br /><br />
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.lics} nome={"Licitacao"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#2cc70277-c3ea-4bf6-aee8-307c42a4d605" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca